import React from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { OptInInvitationWidgetProps } from "../../js/headersegment/interfaces";

const OptInInvitationWidget: React.FC<OptInInvitationWidgetProps> = ({widgetTravelerInvitations}) => {

    return (<>
        <div className="widget">
            <div className="header">
                OPT-IN INVITATIONS
                <OverlayTrigger delay={{ hide: 450, show: 300 }} placement="top"
                    overlay={(props) => (
                        <Tooltip {...props} className="overlay-tooltip">
                            Opt-in invitations sent to passengers to sign-up to receive traveler alerts.
                        </Tooltip>
                )}>
                    <div className="popover-icon sprites sprite-details-selected-16 m-0 margin-left-5"></div>
                </OverlayTrigger>
            </div>

            <div className="data-header">
                <table className="table table-condensed">
                <thead>
                    <tr>
                        <th className="left datetime-width">TIME</th>
                        <th className="left issue-type">EMAIL</th>
                    </tr>
                </thead>
                </table>
            </div>

            <div className="data">
                <table className="table table-condensed">
                    <tbody>
                        {widgetTravelerInvitations.map((travelerInvitation, index) => (
                            <tr key={index}>
                                <td>{travelerInvitation.sentAt}</td>
                                <td>
                                    {travelerInvitation.tripNotificationUrl && (
                                        <a
                                            className="opt-in-invitation-href"
                                            href={travelerInvitation.tripNotificationUrl}
                                            title={travelerInvitation.email}
                                        >
                                            {travelerInvitation.email}
                                        </a>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </>);

}

export default OptInInvitationWidget;